export default __webpack_public_path__ + "static/media/custom-blue.ba0c0fe0.svg";